
import React, { useState } from 'react'
import AddPaymentPopup from 'Popups/AddPaymentPopup/AddPaymentPopup';
import AddPatientPaymentPopup from 'Popups/AddPatientPaymentPopup/AddPatientPaymentPopup';
import PatientPaymentSearchGrid from './PatientPaymentSearchGrid';

const PatientPaymentSearch = ({ handlePaymentId, allowPatientCol=true , rows, handlePerRowsChange, handlePageChange, paramModel, onRowsChange, onRefresh }) => {
  const [paymentPopup, setPaymentPopup] = useState(false)
  const [state, setState] = useState({
    modalRow: null,
    showPaymentDetail: false,
  })

  return (
    <>
      {paymentPopup && <AddPaymentPopup onClose={() => setPaymentPopup(false)} />}
      {state.showPaymentDetail && <AddPatientPaymentPopup modalRow={state.modalRow} onClose={() => setState({ ...state, modalRow: null, showPaymentDetail: false })} />}
      <PatientPaymentSearchGrid
        allowPatientCol={allowPatientCol}
        handlePayment={handlePaymentId}
        rows={rows}
        handlePerRowsChange={handlePerRowsChange}
        handlePageChange={handlePageChange}
        paramModel={paramModel}
        onRowsChange={onRowsChange}
        onRefresh={onRefresh}
      />


    </>
  )
}

export default PatientPaymentSearch
PatientPaymentSearch.displayName = 'PatientPaymentSearch';